(function ($, Drupal) {
    'use strict';
    Drupal.behaviors.kafSubnav = {
      attach: (context) => {
        
        if (!$('.header-subnav', context).length) {
          return;
        }

        $('.header-subnav').on('keydown', function(e) {
            if (e.key === "Escape") {
                var focused = $(':focus');
                window.setTimeout(function() {
                    focused.parents('.subnav-li').children('a').focus();
                }, 1);
                $('.header-subnav .subnav-li').each(function () {
                    $(this).removeClass('open-menu');
                    $(this).children('a').attr('aria-expanded', 'false');
                });
            }

            if (e.key === "Tab") {
                setTimeout(function() {
                    var focused = $(':focus');
                    if (focused.parents('.parent-item.open-menu').length === 0) {
                        $('.header-subnav .subnav-li').each(function () {
                            $(this).removeClass('open-menu');
                            $(this).children('a').attr('aria-expanded', 'false');
                        })
                    }
                }, 1);
            }
        })
        
        $('.header-subnav').on('click', '.subnav-li > a', function(e) {
            e.preventDefault();
            if ($(this).attr('aria-expanded') === 'true') {
                $(this).parent('.subnav-li').removeClass('open-menu');
                $(this).attr('aria-expanded', 'false');
            } else {
                $(this).parent('.subnav-li').addClass('open-menu');
                $(this).attr('aria-expanded', 'true');
            }
        });

        $('.header-subnav .subnav-li').each(function () {
            $(this).mouseover(function() {
                $(this).children('a').attr('aria-expanded', 'true');
                $(this).addClass('open-menu');
            });
            $(this).mouseout(function () {
                $(this).removeClass('open-menu');
                $(this).children('a').attr('aria-expanded', 'false');
            });
        });

      }
    };

})(jQuery, Drupal);